// extracted by mini-css-extract-plugin
export default {"menu":"tech-card-actions_menu__iR9El","menu-icon":"tech-card-actions_menu-icon__59m0g","menu-button":"tech-card-actions_menu-button__6d3YJ"};